export { default } from "@src/Apps/SurvivalAnalysis";
